import React, { useEffect } from 'react'
import { Form, Button, Row, Col, Input, Switch } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from '../Organizations.module.less'
import { GroupInfo } from '~/Services/GroupServices'
const { TextArea } = Input

interface Props {
  onSubmit: (values: any) => void
  onCancel: () => void
  initialData?: GroupInfo | null
}

export const CreateUpdateGroupForm: React.FC<Props> = ({
  onSubmit,
  onCancel,
  initialData,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        code: initialData.code,
        displayName: initialData.name,
        status: initialData.status === 1,
        note: initialData.note,
      })
    } else {
      form.resetFields()
    }
  }, [initialData, form])

  const onFinish = (values: any) => {
    onSubmit && onSubmit(values)
  }

  return (
    <>
      <Form
        className={styles.CreateUpdateForm}
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label={t('groups.code')}
              name="code"
              rules={[{ required: true, message: '' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label={t('groups.displayName')}
              name="displayName"
              rules={[{ required: true, message: '' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label={t('groups.status')}
              name="status"
              valuePropName="checked"
              initialValue={true}
            >
              <Switch defaultChecked />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              label={t('groups.note')}
              name="note"
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        <div className={styles.FooterModal}>
          <Button onClick={onCancel}>{t('cancel')}</Button>
          <Button type="primary" htmlType="submit">
            {t('save')}
          </Button>
        </div>
      </Form>
    </>
  )
}
